// A scan URL carries the tap-ref after the tag-ref, which is always 16 hex
// digits: .../tag/{tagRef}[x][tapRef]. The fixed length makes the split
// positional, and `x` is not a hex digit, so it can never be read as part of the
// tag-ref. The divider and the tap-ref are each optional; without the divider, a
// tap-ref starting with `x` would read as divider + the rest.
const TAP_PATH_PATTERN = /^(.*\/tag\/([0-9a-fA-F]{16}))x?([a-zA-Z0-9]*)$/

export type TapPath = {
  cleanPath: string
  tagRef: string
  // '' when the path has a suffix but no tap-ref (`<tagRef>x`).
  tapRef: string
}

export function splitTapPath(pathname: string): TapPath | null {
  const match = TAP_PATH_PATTERN.exec(pathname)

  // A bare tag path is already clean.
  if (!match || match[0] === match[1]) {
    return null
  }

  return { cleanPath: match[1], tagRef: match[2], tapRef: match[3] }
}

export function stripTapRef(pathname: string): string {
  return splitTapPath(pathname)?.cleanPath ?? pathname
}
